import React, { useContext, useEffect } from "react"
import { Helmet } from 'react-helmet'
import PropTypes from "prop-types"
import { Link, useStaticQuery, graphql } from "gatsby"
import { Message } from "theme-ui"
import { ThemeContext } from "../context/themeContext"
import Navbar from "./Globals/Navbar"
import Footer from "./Globals/Footer"
import config from "../../config/website"
import "./layout.css"

const shortcodes = { Message }

const copyToClipboard = e => {
  const textToClip = e.currentTarget?.href
  navigator.clipboard.writeText(textToClip)
}

const Layout = ({ 
  headerLink,
  siteTitle = 'Danniel Hansel',
  frontmatter = {},
  location,
  hero,
  subscribeForm,
  children,
  dark,
  headerBg,
  headerColor,
  noFooter,
  backgroundColor,
  backgroundImage,
  fixedHeader,
  logo,
  maxWidth = 720,
}) => {
  // const rootPath = `${__PATH_PREFIX__}/`
  // const isRootPath = location.pathname === rootPath
  // let header
  const { theme, setTheme } = useContext(ThemeContext)
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          author {
            name
          }
          keywords
        }
      }
    }
  `)
  const {
    site: {
      siteMetadata,
      siteMetadata: {description: siteDescription, keywords: siteKeywords},
    },
  } = data
  const {
    keywords = siteKeywords,
    description = siteDescription,
    title = config.siteTitle,
  } = frontmatter

  useEffect(() => {
    const headers = document.querySelectorAll('.autolinked-header')
    headers.forEach(headerEl => {
      headerEl.addEventListener('click', copyToClipboard)
    })
    return () =>
      headers.forEach(headerEl =>
        headerEl.removeEventListener('click', copyToClipboard),
      )
  }, [])

  return (
    // <div className="global-wrapper" data-is-root-path={isRootPath}>
    <div className="global-wrapper">
      <Helmet
        title={title}
        meta={[
          // {name: 'robots', content: 'noindex'},
          {name: 'description', content: description},
          {name: 'keywords', content: keywords.join(", ")},
        ]}
        // data-is-root-path={isRootPath}
      >
        <html lang="en" />
        <script src="https://js.tito.io/v1" async />
        <noscript>This site runs best with JavaScript enabled.</noscript>
      </Helmet>
      <div
        className={`${
          theme === "light" ? "theme-light" : "theme-dark dark"
        } bg-primary text-main-text antialiased whitespace-prewrap overscroll-x-none min-h-screen scroll-smooth snap-y`}
      >
        {/* <header className="global-header"> */}
          <Navbar 
            siteTitle={siteTitle}
            // headerLink={headerLink}
            // dark={dark}
            // bgColor={headerBg}
            // headerColor={headerColor}
            // fixed={fixedHeader}
            // headerImage={logo}
          />
        {/* </header> */}
        <main>{children}</main>
        {/* <ContactComponent /> */}
        <Footer author={siteMetadata.author.name} />
      </div>
    </div>
  )
}

// Layout.propTypes = {
//   // children: PropTypes.node.isRequired,
//   children: PropTypes.any,
// }

export default Layout
